import ThermalPrinterEncoder, {
  ThermalPrinterEncoderOption,
} from "../../lib/thermal-printer-encoder"
import { format, parseISO } from "date-fns"
import { Business } from "../models"
import { Locations } from "../../hooks/api/use-locations"
import { GiftCard } from "../../hooks/api/use-gift-cards"

export const encodeGiftCard = async (
  business: Business,
  giftCard: GiftCard,
  location: {
    name: string
  },
  encoderOptions: ThermalPrinterEncoderOption = {
    language: "esc-pos",
    columns: 32,
    feedBeforeCut: 1,
  }
) => {
  let encoder = new ThermalPrinterEncoder({
    ...encoderOptions,
    imageMode: "raster",
  }).initializeWithMultiByte()

  //add a line
  encoder = encoder.newline()

  //business name
  encoder = encoder
    .align("center")
    .bold(true)
    .line(business.name)
    .bold(false)
    .newline()

  //Gift Certificate text in big font
  encoder = encoder
    .align("center")
    .bold(true)
    .line("GIFT CERTIFICATE")
    .bold(false)
    .newline()

  //Code: {code}
  encoder = encoder.align("center").line(`Code: ${giftCard.code}`).newline()

  //Value: {value}
  encoder = encoder
    .align("center")
    .line(`Value: ${giftCard.amount.toFixed(2)}`)
    .newline()

  //Expiry: {expiry}
  if (giftCard.expiresAt) {
    encoder = encoder
      .align("center")
      .line(`Expiry: ${format(parseISO(giftCard.expiresAt), "MM/dd/yyyy")}`)
      .newline()
  }

  //Issued By: {location.name}
  encoder = encoder
    .align("center")
    .line(`Issued By: ${location.name}`)
    .newline()

  //barcode
  encoder = encoder
    .newline()
    .align("center")
    .barcode(giftCard.code, "code128", {
      width: 1,
      text: true,
    })

  //Please present this voucher at checkout
  encoder = encoder
    .newline()
    .align("center")
    .line("Please present this voucher at checkout")
    .newline()

  return encoder.newline().cut().encode()
}
